const integrations = {
    en: {
        "intg.title": "Integrations",
        "intg.hint": "Connect external services. Each works only once enabled and configured; leave a secret blank to keep the stored one.",
        "intg.enabled": "Enabled",
        "intg.configured": "Configured",
        "intg.notConfigured": "Not configured",
        "intg.save": "Save",
        "intg.test": "Test",
        "intg.auction": "Auction API",
        "intg.carrier": "Carrier tracking",
        "intg.s3": "S3 file storage",
        "intg.baseUrl": "Base URL",
        "intg.apiKey": "API key",
        "intg.region": "Region",
        "intg.bucket": "Bucket",
        "intg.accessKey": "Access key ID",
        "intg.secretKey": "Secret access key",
        "intg.secretSet": "(stored — leave blank to keep)",
        "intg.lot": "Lot number",
        "intg.vin": "VIN",
        "intg.tracking": "Tracking number",
        "intg.fetch": "Fetch",
        "intg.track": "Track",
        "intg.result": "Result",
        "intg.s3SdkMissing": "AWS SDK not installed — install @aws-sdk/client-s3 on the server to enable S3 uploads.",
        "intg.saved": "Saved",
    },
    ru: {
        "intg.title": "Интеграции",
        "intg.hint": "Подключение внешних сервисов. Работает после включения и настройки; оставьте секрет пустым, чтобы сохранить текущий.",
        "intg.enabled": "Включено",
        "intg.configured": "Настроено",
        "intg.notConfigured": "Не настроено",
        "intg.save": "Сохранить",
        "intg.test": "Тест",
        "intg.auction": "API аукциона",
        "intg.carrier": "Отслеживание перевозчика",
        "intg.s3": "Хранилище S3",
        "intg.baseUrl": "Базовый URL",
        "intg.apiKey": "API-ключ",
        "intg.region": "Регион",
        "intg.bucket": "Бакет",
        "intg.accessKey": "Access key ID",
        "intg.secretKey": "Secret access key",
        "intg.secretSet": "(сохранён — оставьте пустым)",
        "intg.lot": "Номер лота",
        "intg.vin": "VIN",
        "intg.tracking": "Номер отслеживания",
        "intg.fetch": "Получить",
        "intg.track": "Отследить",
        "intg.result": "Результат",
        "intg.s3SdkMissing": "AWS SDK не установлен — установите @aws-sdk/client-s3 на сервере для загрузок в S3.",
        "intg.saved": "Сохранено",
    },
    geo: {
        "intg.title": "ინტეგრაციები",
        "intg.hint": "გარე სერვისების დაკავშირება. მუშაობს ჩართვისა და კონფიგურაციის შემდეგ; საიდუმლო ცარიელად დატოვეთ არსებულის შესანარჩუნებლად.",
        "intg.enabled": "ჩართული",
        "intg.configured": "კონფიგურირებული",
        "intg.notConfigured": "არ არის კონფიგურირებული",
        "intg.save": "შენახვა",
        "intg.test": "ტესტი",
        "intg.auction": "აუქციონის API",
        "intg.carrier": "გადამზიდავის თრექინგი",
        "intg.s3": "S3 ფაილსაცავი",
        "intg.baseUrl": "ბაზის URL",
        "intg.apiKey": "API გასაღები",
        "intg.region": "რეგიონი",
        "intg.bucket": "Bucket",
        "intg.accessKey": "Access key ID",
        "intg.secretKey": "Secret access key",
        "intg.secretSet": "(შენახულია — ცარიელად დატოვეთ შესანარჩუნებლად)",
        "intg.lot": "ლოტის ნომერი",
        "intg.vin": "VIN",
        "intg.tracking": "თრექინგის ნომერი",
        "intg.fetch": "მოტანა",
        "intg.track": "თრექინგი",
        "intg.result": "შედეგი",
        "intg.s3SdkMissing": "AWS SDK არ არის დაყენებული — დააყენეთ @aws-sdk/client-s3 სერვერზე S3 ატვირთვებისთვის.",
        "intg.saved": "შენახულია",
    },
};

export default integrations;
